/* eslint-disable react/no-array-index-key */
import { Eye } from 'lucide-react';
import { useState } from 'react';

function ImageContainer(props) {
	const { images = [], handleClick = () => {} } = props;
	const [hoveredImage, setHoveredImage] = useState(null);

	return (
		<div className='w-full max-h-[500px] bg-slate-200 p-4 rounded-md overflow-y-auto'>
			<div className='grid grid-cols-7 gap-2'>
				{Array.isArray(images) && images.length > 0 ? (
					images.map((imgSrc, index) => (
						<div
							key={`${index}-${imgSrc}`}
							className='relative group w-[130px] h-[130px] rounded-md overflow-hidden'
							onMouseEnter={() => setHoveredImage(imgSrc)}
							onMouseLeave={() => setHoveredImage(null)}
						>
							<img
								src={imgSrc}
								alt='WastageImage'
								className='w-full h-full rounded-lg'
							/>
							{hoveredImage === imgSrc && (
								<div
									className='absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 cursor-pointer rounded-lg'
									onClick={() => handleClick(imgSrc)}
								>
									<Eye className='text-white w-8 h-8' />
								</div>
							)}
						</div>
					))
				) : (
					<div className='text-gray-500 col-span-4 text-center'>No images available</div>
				)}
			</div>
		</div>

	);
}

export default ImageContainer;
